import { AuthRepository } from '../../domain/repositories/AuthRepository';
import { AuthFirebaseRepository } from '../repositories/AuthFirebaseRepository';

/**
 * AuthDependencyContainer (IoC)
 *
 * Responsabilidad única: proveer el repositorio concreto.
 * Los hooks consumen el repositorio directamente — no hay use cases intermedios.
 *
 * Nota: también usado por api.ts (shared/services) para obtener el JWT en cada request.
 *
 * Para testing: inyectar mock con setAuthRepository().
 */
export class AuthDependencyContainer {
  private static authRepository: AuthRepository;

  static getAuthRepository(): AuthRepository {
    if (!this.authRepository) {
      this.authRepository = new AuthFirebaseRepository();
    }
    return this.authRepository;
  }

  static setAuthRepository(repository: AuthRepository): void {
    this.authRepository = repository;
  }

  static reset(): void {
    this.authRepository = null as any;
  }
}
